import { getTranslation } from '@helpers/languageTranslations';
import { useTranslation } from '@stateManagement/TranslationContext';
import { SelectOption } from '@web-for-marketing/react-ui';
import { useMemo } from 'react';
import { LazyLoadedSelectOptionsTypes, useLazyLoadedSelectOptions } from './useLazyLoadedSelectOptions';
import { DropdownType } from '@models/customForm';

interface IndustryFieldProps {
    id: string;
    name: string;
    label: string;
    placeholder: string;
}

const selectOptions: LazyLoadedSelectOptionsTypes[] = [DropdownType.Industry];

export function useIndustryDropdown(): [IndustryFieldProps, SelectOption[]] {
    const { selectedLanguageTranslation } = useTranslation();
    const formTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formTranslations');
    }, [selectedLanguageTranslation]);
    const placeholderTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formPlaceholders');
    }, [selectedLanguageTranslation]);
    const [industryOptions] = useLazyLoadedSelectOptions(selectOptions);

    const industryProps = {
        id: 'industry',
        name: 'industry',
        label: formTranslations.industry || 'Industry',
        placeholder: placeholderTranslations.industryPlaceholder || 'Select an industry category\u2026',
    };

    return [industryProps, industryOptions];
}
